import React from 'react'
import styled from 'styled-components'

import Tooltip from 'components/Tooltip'
import Checkbox from 'components/Checkbox'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

const ACKNOWLEDGE_NEW_MESSAGE = "Don't show this customer as \"New\" Customer in my customer list."
const ACKNOWLEDGE_UPDATED_MESSAGE = "Don't show this customer as \"Updated\" Customer in my customer list."
const ACKNOWLEDGE_DUPLICATE_MESSAGE = "Don't show this customer as \"Duplicate\" Customer in my customer list."

type Props = {
  isNewAndUnacknowledged: boolean | null
  isUpdatedAndUnacknowledged: boolean | null
  isDuplicateAndUnacknowledged: boolean | null
  isUpdateAcknowledged: boolean
  piiHomeDuplicateNames: string | null
  piiAcknowledgedAt: string | null
  piiDuplicateAck: boolean | null
  orginalPiiAcknowledgedAt?: string | null
  onChangeCallback: (customerAttributes) => void
}

const PiiFlags = (
  {
    isNewAndUnacknowledged,
    isUpdatedAndUnacknowledged,
    isDuplicateAndUnacknowledged,
    isUpdateAcknowledged,
    piiHomeDuplicateNames,
    piiAcknowledgedAt,
    piiDuplicateAck,
    orginalPiiAcknowledgedAt,
    onChangeCallback
  }: Props) => {
  return (
    <>
      {isNewAndUnacknowledged && (
        <S.NewFlag>NEW</S.NewFlag>
      )}

      {isUpdatedAndUnacknowledged && (
        <S.UpdatedFlag>UPDATED</S.UpdatedFlag>
      )}

      {isDuplicateAndUnacknowledged && (
        <Tooltip title={`This might be a duplicate account. Also see ${piiHomeDuplicateNames}`} placement="top">
          <S.DuplicateFlag>DUPLICATE</S.DuplicateFlag>
        </Tooltip>
      )}

      {isDuplicateAndUnacknowledged && (
        <S.DescriptionOfDuplicates>This could be a duplicate account. We have identified that this account has the same home info as "{piiHomeDuplicateNames}".
          You can merge these two accounts by removing the system(s) from one and adding to the other (and then deleting the empty account).
          If these are not duplicates, you can edit this customer to remove the duplicate flag.
        </S.DescriptionOfDuplicates>
      )}

      {isNewAndUnacknowledged && (
        <S.AcknowledgePiiCheckbox
            label={ACKNOWLEDGE_NEW_MESSAGE}
            checked={piiAcknowledgedAt != null}
            onChange={() => onChangeCallback({ piiAcknowledgedAt: !piiAcknowledgedAt ? new Date().toUTCString() : null })}
        />
      )}

      {isUpdatedAndUnacknowledged && (
        <S.AcknowledgePiiCheckbox
          label={ACKNOWLEDGE_UPDATED_MESSAGE}
          checked={!isUpdateAcknowledged}
          onChange={() => onChangeCallback(
            { piiAcknowledgedAt: isUpdateAcknowledged ? new Date().toUTCString() : orginalPiiAcknowledgedAt }
          )}
        />
      )}

      {isDuplicateAndUnacknowledged && (
        <S.AcknowledgePiiCheckbox
          label={ACKNOWLEDGE_DUPLICATE_MESSAGE}
          checked={piiDuplicateAck || false}
          onChange={() => onChangeCallback({ piiDuplicateAck: !piiDuplicateAck }
          )}
        />
      )}
    </>
  )
}

export default PiiFlags

const S = {
  DescriptionOfDuplicates: styled.div`
    padding: 0 15px;
    color: ${color('secondaryText')}  
  `,
  AcknowledgePiiCheckbox: styled(Checkbox)`
    padding: 0px 15px 15px 0px;
    display: flex;
    align-items: baseline;

    @media ${screenSize.small} {
      padding: 15px 15px 15px 0px;

      > label {
        white-space: normal;
      }
    }
  `,
  NewFlag: styled.div`
    display: inline-block;
    width: 60px;
    font-weight: bold;
    border-radius: 5px;
    background: #F0EEEC;
    text-align: center;
    margin: 24px 0 0 15px;
  `,
  UpdatedFlag: styled.div`
    display: inline-block;
    width: 80px;
    font-weight: bold;
    border-radius: 5px;
    background: #F0EEEC;
    text-align: center;
    margin: 24px 0 0 15px;
  `,
  DuplicateFlag: styled.div`
    display: inline-block;
    width: 80px;
    font-weight: bold;
    border-radius: 5px;
    background: #F0EEEC;
    text-align: center;
    margin: 24px 0 0 15px;
  `,
  Explanation: styled.p`
    margin-top: 13px;
  `
}
